<template>
	<div>
		<titles titlename="预约实训记录查询" titlecontent="预约实训记录查询" :mbx="paths"></titles>
		<filters :rooms="filterslist"></filters>

		<el-dialog :show-close="false" :title="diolotitle" :visible.sync="centerDialogVisible" width="50%" center>
			<div v-if="looksnum == 1">
				<el-descriptions border :column="2">
					<el-descriptions-item label="真实姓名">{{ tabledeobj.ui_realName }}</el-descriptions-item>
					<el-descriptions-item label="头像">
						<el-popover placement="top-start" title="" trigger="hover">
							<img v-if="tabledeobj.ui_photoPath == null" src="../../images/header.jpg" alt="这是默认的" style="width: 150px;height: 150px;border-radius: 50%;" />
							<img v-if="tabledeobj.ui_photoPath != null" :src="tabledeobj.ui_photoPath" alt="这是后台的" style="width: 150px;height: 150px;border-radius: 50%;" />
							<img v-if="tabledeobj.ui_photoPath == null" slot="reference" src="../../images/header.jpg" style="width: 40px;height: 40px;border-radius: 50%;" />
							<img v-if="tabledeobj.ui_photoPath != null" slot="reference" :src="tabledeobj.ui_photoPath" style="width: 40px;height: 40px;border-radius: 50%;" />
						</el-popover>
					</el-descriptions-item>
					<el-descriptions-item label="所属学校">{{ tabledeobj.si_name_cn }}</el-descriptions-item>

					<el-descriptions-item label="所属专业">{{ tabledeobj.pro_name }}</el-descriptions-item>
					<el-descriptions-item label="所属班级">{{ tabledeobj.cla_name }}</el-descriptions-item>
					<el-descriptions-item label="预约设备" v-if="trainname == '实训设备'">{{ tabledeobj.te_deviceName }}</el-descriptions-item>
					<el-descriptions-item label="预约时间段">{{ tabledeobj.te_createTime }} {{ tabledeobj.ap_startTime }} ~ {{ tabledeobj.ap_endTime }}</el-descriptions-item>
					<!-- <el-descriptions-item label="预约实训日期">
						{{tabledeobj.ap_appDate}}
					</el-descriptions-item>
 -->
					<el-descriptions-item label="审核状态">{{ tabledeobj.ap_auditState }}</el-descriptions-item>
					<el-descriptions-item label="预约说明">{{ tabledeobj.ap_appContent }}</el-descriptions-item>
					<el-descriptions-item label="审核说明">{{ tabledeobj.ap_auditContent }}</el-descriptions-item>
				</el-descriptions>
			</div>

			<div v-if="looksnum == 2">
				<el-descriptions border :column="2">
					<el-descriptions-item label="真实姓名">{{ tabledeobj1.ui_realName }}</el-descriptions-item>
					<el-descriptions-item label="头像">
						<el-popover placement="top-start" title="" trigger="hover">
							<img v-if="tabledeobj1.ui_photoPath == null" src="../../images/header.jpg" alt="" style="width: 150px;height: 150px;border-radius: 50%;" />
							<img v-if="tabledeobj1.ui_photoPath != null" :src="tabledeobj.ui_photoPath" alt="" style="width: 150px;height: 150px;border-radius: 50%;" />
							<img v-if="tabledeobj1.ui_photoPath == null" slot="reference" src="../../images/header.jpg" style="width: 40px;height: 40px;border-radius: 50%;" />
							<img v-if="tabledeobj1.ui_photoPath != null" slot="reference" :src="tabledeobj.ui_photoPath" style="width: 40px;height: 40px;border-radius: 50%;" />
						</el-popover>
					</el-descriptions-item>
					<el-descriptions-item label="所属学校">{{ tabledeobj1.si_name_cn }}</el-descriptions-item>
					<el-descriptions-item label="所属班级">{{ tabledeobj1.cla_name }}</el-descriptions-item>
					<el-descriptions-item label="所属专业">{{ tabledeobj1.pro_name }}</el-descriptions-item>
					<el-descriptions-item label="实训设备">{{ tabledeobj1.te_deviceName }}</el-descriptions-item>
					<el-descriptions-item label="实训项目">{{ tabledeobj1.projectName }}</el-descriptions-item>
					<el-descriptions-item label="实训成绩">{{ tabledeobj1.projecScore }}</el-descriptions-item>
					<el-descriptions-item label="实训开始时间">{{ tabledeobj1.TDT_StartTime }}</el-descriptions-item>
					<el-descriptions-item label="实训结束时间">{{ tabledeobj1.TDT_EndTime }}</el-descriptions-item>
					<el-descriptions-item label="预约说明">{{ tabledeobj.ap_appContent }}</el-descriptions-item>
				</el-descriptions>
			</div>

			<el-form :model="form" v-if="looksnums == 3">
				<el-form-item label="请选择是否通过">
					<el-radio-group v-model="form.resource">
						<el-radio label="通过"></el-radio>
						<el-radio label="驳回"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="通过或者驳回说明"><el-input type="textarea" v-model="form.desc" placeholder="当前值可以选填,可以为空"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="oktable()" v-preventReClick>确 定</el-button>
			</span>
		</el-dialog>

		<div style="margin: 1rem 0;"></div>
		<el-tabs type="border-card" v-model="sletejg" @tab-click="handleClick">
			<el-tab-pane label="实训设备预约记录" name="1">
				<transition>
					<div class="orderstable" v-if="sletejg == 1">
						<p class="schooltitle">
							<span class="el-icon-s-management"></span>
							<span>实训设备预约记录</span>
							<span class="schoolconten">
								共查询到
								<i>{{ tablednums }}条</i>
								符合的记录
							</span>
						</p>
						<div class="paginations">
							每页显示
							<input @click="changetavles()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesize" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
									<el-table-column type="index" :resizable="false" label="序号" width="50"></el-table-column>
									<el-table-column label="头像" :resizable="false" width="70" center>
										<template slot-scope="scope">
											<el-popover placement="top-start" title="" trigger="hover">
												<img v-if="scope.row.ui_photoPath == null" src="../../images/seleteheader.svg" alt="" style="width: 150px;height: 150px" />
												<img v-if="scope.row.ui_photoPath == null" slot="reference" src="../../images/seleteheader.svg" style="width: 40px;height: 40px" />
												<img v-if="scope.row.ui_photoPath !== null" :src="scope.row.ui_photoPath" alt="" style="width: 150px;height: 150px" />
												<img v-if="scope.row.ui_photoPath !== null" slot="reference" :src="scope.row.ui_photoPath" style="width: 40px;height: 40px" />
											</el-popover>
										</template>
									</el-table-column>
									<el-table-column prop="ui_realName" :resizable="false" label="真实姓名" width="100">
										<template slot-scope="scope">
											<p :title="scope.row.ui_realName" :resizable="false" style="width: 100%;text-align: center;">{{ scope.row.ui_realName }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="si_name_cn" :resizable="false" label="院校">
										<template slot-scope="scope">
											<p :title="scope.row.si_name_cn" style="width: 100%;">{{ scope.row.si_name_cn }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="cla_name" :resizable="false" label="班级">
										<template slot-scope="scope">
											<p :title="scope.row.cla_name" style="width: 100%;">{{ scope.row.cla_name }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="tr_name" :resizable="false" label="实训室">
										<template slot-scope="scope">
											<p :title="scope.row.tr_name" style="width: 100%;">{{ scope.row.tr_name }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="te_deviceName" label="预约设备" width="120">
										<template slot-scope="scope">
											<p :title="scope.row.te_deviceName" style="width: 100%;">{{ scope.row.te_deviceName }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="ap_appDate" :resizable="false" label="预约时间">
										<template slot-scope="scope">
											<p>{{ scope.row.ap_appDate }} {{ scope.row.ap_startTime }} ~ {{ scope.row.ap_endTime }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="ap_appContent" :resizable="false" label="预约申请说明">
										<template slot-scope="scope">
											<p :style="{ color: scope.row.ap_appContent == '' || !scope.row.ap_appContent ? 'red' : '' }">
												{{ scope.row.ap_appContent == '' || !scope.row.ap_appContent ? '暂无说明' : scope.row.ap_appContent }}
											</p>
										</template>
									</el-table-column>
									<!-- <el-table-column prop="te_createTime" label="预约实训日期">
									</el-table-column> -->
									<!-- <el-table-column label="预约实训时间段" width="130">
										<template slot-scope="scope">
											<p>{{scope.row.ap_appDate}}  {{scope.row.ap_startTime}} ~ {{scope.row.ap_endTime}}</p>
										</template>
									</el-table-column> -->
									<el-table-column prop="shzt" :resizable="false" label="审核状态" width="150">
										<template slot-scope="scope">
											<p
												style="text-align: center; padding: 0 10px; border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #af080b;"
												v-if="scope.row.ap_auditState == '已取消'"
											>
												{{ scope.row.ap_auditState }}
											</p>

											<p
												style="text-align: center;padding: 0 10px; border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #ff4141;"
												v-if="scope.row.ap_auditState == '已驳回'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="text-align: center;padding: 0 10px;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #FFA319 ;"
												v-if="scope.row.ap_auditState == '待审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="text-align: center;padding: 0 10px;border: 1px solid;width: 70%;margin: 0 auto;border-radius: 13px;color: #fff;background: #1cdf84;"
												v-if="scope.row.ap_auditState == '审核通过'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="text-align: center;padding: 0 10px;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #1cdf84;"
												v-if="scope.row.ap_auditState == '已审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
										</template>
									</el-table-column>
									<!-- fixed="right" -->
									<el-table-column label="操作" width="100">
										<template slot-scope="scope">
											<div class="userusec d-sm-none d-md-block">
												<el-button size="small" :class="'looking'" @click="lookindg(scope.row, '实训设备')">
													<!-- <span class="el-icon-view" style="color: #fff;"></span> -->
													查看
												</el-button>
												<el-button v-if="scope.row.ap_auditState == '待审核'" size="small" class="delete" @click="tabledeletes(scope.row, 0)">
													<!-- <span class="el-icon-delete" style="color: #fff;"></span> -->
													审核
												</el-button>
											</div>
											<div class="userusec d-sm-block d-md-none">
												<el-dropdown trigger="click">
													<p class="el-dropdown-link">···</p>
													<el-dropdown-menu slot="dropdown">
														<el-button
															size="small"
															:class="'looking'"
															style="margin: 0 0.4rem; background-color: #1933df;"
															@click="lookindg(scope.row, '实训设备')"
														>
															<span style="color: #fff;">查看</span>
															<!-- <span class="el-icon-view" style="color: #fff;"></span> -->
														</el-button>
														<el-button v-if="scope.row.ap_auditState == '待审核'" size="small" class="delete" @click="tabledeletes(scope.row, 0)">
															<!-- <span class="el-icon-delete" style="color: #fff;"></span> -->
															<span style="color: #fff;">审核</span>
														</el-button>
													</el-dropdown-menu>
												</el-dropdown>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</div>

						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ pagesize }}</span>
								,共
								<span>{{ tablednums }}</span>
								条记录
							</p>
							<div class="elpagian">
								<el-pagination
									@current-change="handleCurrentChange"
									background
									layout="prev, pager, next"
									:page-size="pagesizes"
									:total="tablednums"
								></el-pagination>
							</div>
						</div>
					</div>
				</transition>
			</el-tab-pane>

			<el-tab-pane label="实训室预约记录" name="3">
				<transition>
					<div class="orderstable" v-if="sletejg == 3">
						<p class="schooltitle">
							<span class="el-icon-s-management"></span>
							<span>实训室预约记录</span>
							<span class="schoolconten">
								共查询到
								<i>{{ tablednumstrain }}条</i>
								符合的记录
							</span>
						</p>
						<div class="paginations">
							每页显示
							<input @click="changetavles()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesize" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table :data="tableDatatrin" header-row-class-name="tablestitle" border style="width: 100%">
									<el-table-column type="index" label="序号" width="50"></el-table-column>
									<el-table-column label="头像" width="70">
										<template slot-scope="scope">
											<el-popover placement="top-start" title="" trigger="hover">
												<img v-if="scope.row.ui_photoPath == null" src="../../images/seleteheader.svg" alt="" style="width: 150px;height: 150px" />
												<img v-if="scope.row.ui_photoPath == null" slot="reference" src="../../images/seleteheader.svg" style="width: 40px;height: 40px" />
												<img v-if="scope.row.ui_photoPath !== null" :src="scope.row.ui_photoPath" alt="" style="width: 150px;height: 150px" />
												<img v-if="scope.row.ui_photoPath !== null" slot="reference" :src="scope.row.ui_photoPath" style="width: 40px;height: 40px" />
											</el-popover>
										</template>
									</el-table-column>
									<el-table-column prop="ui_realName" label="真实姓名" width="80">
										<template slot-scope="scope">
											<p :title="scope.row.ui_realName" style="width: 100%;">{{ scope.row.ui_realName }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="si_name_cn" label="院校" width="180">
										<template slot-scope="scope">
											<p :title="scope.row.si_name_cn" style="width: 100%;">{{ scope.row.si_name_cn }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="cla_name" label="班级"></el-table-column>
									<el-table-column prop="tr_name" label="预约实训室">
										<template slot-scope="scope">
											<p :title="scope.row.tr_name" style="width: 100%;">{{ scope.row.tr_name }}</p>
										</template>
									</el-table-column>

									<!-- <el-table-column prop="te_deviceName" label="预约设备">
									</el-table-column> -->
									<el-table-column prop="ap_appDate" label="预约时间" width="200">
										<template slot-scope="scope">
											<p>{{ scope.row.ap_appDate }} {{ scope.row.ap_startTime }} ~ {{ scope.row.ap_endTime }}</p>
										</template>
									</el-table-column>

									<el-table-column prop="ap_appContent" label="预约申请说明">
										<template slot-scope="scope">
											<p :style="{ color: scope.row.ap_appContent == '' || !scope.row.ap_appContent ? 'red' : '' }">
												{{ scope.row.ap_appContent == '' || !scope.row.ap_appContent ? '暂无说明' : scope.row.ap_appContent }}
											</p>
										</template>
									</el-table-column>
									<el-table-column prop="shzt" label="审核状态" width="150">
										<template slot-scope="scope">
											<p
												style="text-align: center; padding: 0 10px; border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #af080b;"
												v-if="scope.row.ap_auditState == '已取消'"
											>
												{{ scope.row.ap_auditState }}
											</p>

											<p
												style="text-align: center; padding: 0 10px; border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #ff4141;"
												v-if="scope.row.ap_auditState == '已驳回'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="text-align: center; padding: 0 10px;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #FFA319 ;"
												v-if="scope.row.ap_auditState == '待审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="text-align: center; padding: 0 10px;border: 1px solid;width: 70%;margin: 0 auto;border-radius: 13px;color: #fff;background: #1cdf84;"
												v-if="scope.row.ap_auditState == '审核通过'"
											>
												{{ scope.row.ap_auditState }}
											</p>
											<p
												style="text-align: center; padding: 0 10px;border: 1px solid;width: 60%;margin: 0 auto;border-radius: 13px;color: #fff;background: #1cdf84;"
												v-if="scope.row.ap_auditState == '已审核'"
											>
												{{ scope.row.ap_auditState }}
											</p>
										</template>
									</el-table-column>
									<!-- fixed="right" -->
									<el-table-column label="操作" width="150">
										<template slot-scope="scope">
											<div class="userusec d-sm-none d-md-block">
												<el-button size="small" :class="'looking'" @click="lookindg(scope.row, '实训室')">
													<!-- <span class="el-icon-view" style="color: #fff;"></span> -->
													查看
												</el-button>
												<el-button v-if="scope.row.ap_auditState == '待审核'" size="small" class="delete" @click="tabledeletes(scope.row, 1)">
													<!-- <span class="el-icon-delete" style="color: #fff;"></span> -->
													审核
												</el-button>
											</div>
											<div class="userusec d-sm-block d-md-none">
												<el-dropdown trigger="click">
													<p class="el-dropdown-link">···</p>
													<el-dropdown-menu slot="dropdown">
														<el-button
															size="small"
															:class="'looking'"
															style="margin: 0 0.4rem; background-color: #1933df;"
															@click="lookindg(scope.row, '实训室')"
														>
															<span style="color: #fff;">查看</span>
															<!-- <span class="el-icon-view" style="color: #fff;"></span> -->
														</el-button>
														<el-button v-if="scope.row.ap_auditState == '待审核'" size="small" class="delete" @click="tabledeletes(scope.row, 1)">
															<!-- <span class="el-icon-delete" style="color: #fff;"></span> -->
															<span style="color: #fff;">审核</span>
														</el-button>
													</el-dropdown-menu>
												</el-dropdown>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</div>

						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ pagesize }}</span>
								,共
								<span>{{ tablednumstrain }}</span>
								条记录
							</p>
							<div class="elpagian">
								<el-pagination
									@current-change="handleCurrentChange"
									background
									layout="prev, pager, next"
									:page-size="pagesizes"
									:total="tablednumstrain"
								></el-pagination>
							</div>
						</div>
					</div>
				</transition>
			</el-tab-pane>

			<el-tab-pane label="实训记录" name="2">
				<transition>
					<div class="orderstable core" v-if="sletejg == 2">
						<p class="schooltitle">
							<span class="el-icon-s-management icnns"></span>
							<span>实训记录结果查询</span>
							<span class="schoolconten">
								共查询到
								<i>{{ tablednums1 }}条</i>
								符合的记录
							</span>
							<button @click="exportTrainResults()" v-preventReClick>成绩导出</button>
						</p>
						<div class="paginations">
							每页显示
							<input @change="paginationschnge()" type="number" v-model="pagesize1" />
							行
						</div>
						<div class="tabslis">
							<template>
								<el-table :data="tableDatas" border style="width: 100%">
									<el-table-column fixed type="index" label="序号" width="50"></el-table-column>
									<el-table-column prop="headert" label="头像" width="70">
										<template slot-scope="scope">
											<el-popover placement="top-start" title="" trigger="hover">
												<img v-if="scope.row.ui_photoPath == null" src="../../images/header.png" alt="" class="rands" style="width: 150px;height: 150px" />
												<img
													v-if="scope.row.ui_photoPath == null"
													slot="reference"
													src="../../images/header.png"
													class="rands"
													style="width: 40px;height: 40px"
												/>
												<img v-if="scope.row.ui_photoPath !== null" :src="scope.row.ui_photoPath" alt="" class="rands" style="width: 150px;height: 150px" />
												<img
													v-if="scope.row.ui_photoPath !== null"
													slot="reference"
													:src="scope.row.ui_photoPath"
													class="rands"
													style="width: 40px;height: 40px"
												/>
											</el-popover>
											<span>{{ scope.scope }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="ui_realName" label="真实姓名" width="80">
										<template slot-scope="scope">
											<p :title="scope.row.ui_realName" style="width: 100%;">{{ scope.row.ui_realName }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="TDT_EndTime" label="实训时间" width="180"></el-table-column>
									<!-- <el-table-column prop="pro_name" label="院校">
									</el-table-column>
									<el-table-column prop="cla_name" label="班级">
									</el-table-column> -->
									<el-table-column prop="tr_name" label="实训室">
										<template slot-scope="scope">
											<p :title="scope.row.tr_name" style="width: 100%;">{{ scope.row.tr_name }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="te_deviceName" label="设备">
										<template slot-scope="scope">
											<p :title="scope.row.te_deviceName" style="width: 100%;">{{ scope.row.te_deviceName }}</p>
										</template>
									</el-table-column>
									<!-- <el-table-column prop="te_deviceName" label="实训设备">
									</el-table-column> -->
									<!-- <el-table-column prop="projectName" label="实训类型" width="100">
									</el-table-column> -->
									<el-table-column prop="projectName" label="实训项目"></el-table-column>
									<el-table-column label="实训成绩" width="80">
										<template slot-scope="scope">
											<p style="color: #fe0a2e;text-align: center;">{{ scope.row.projecScore }}分</p>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作" width="100">
										<template slot-scope="scope">
											<div class="userusec d-sm-none d-md-block">
												<el-button @click="lookstrainjl(scope.row)" size="small" :class="'looking'" :datascope="scope.row">查看</el-button>
											</div>
											<div class="userusec d-sm-block d-md-none">
												<el-dropdown trigger="click">
													<p class="el-dropdown-link">···</p>
													<el-dropdown-menu slot="dropdown">
														<el-button @click="lookstrainjl(scope.row)" size="small" :class="'looking'" style="margin: 0 0.6rem;">查看</el-button>
													</el-dropdown-menu>
												</el-dropdown>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</div>

						<div class="tabsnum">
							<p>
								显示
								<span>1</span>
								到
								<span>{{ pagesize1 }}</span>
								,共
								<span>{{ tablednums1 }}</span>
								条记录
							</p>
							<div class="elpagian">
								<el-pagination
									@current-change="handleCurrentChange1"
									background
									layout="prev, pager, next"
									:page-size="pagesize1s"
									:total="tablednums1"
								></el-pagination>
							</div>
						</div>
					</div>
				</transition>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import filters from '@/components/filters/filters.vue';
import { xlsx } from '@/utils/tabgo.js';
import {
	GetPageAppointDataList,
	GetPageTrainDataList,
	GetPageTrainDataListApi, //实训记录
	GetyyTrainEquipmentList,
	GetyyGetTrainList,
	GetyyGetClassList,
	AppointmentOnAudit,
	GetPagesxAppointDataList
} from '@/request/api/dataorder/dataprder.js';
import { GetbjGetSchoolList, ClassInfoGetClassList, TrainGetTrainList, GetbjPageClassList, TrainGetPageTrainList } from '@/request/api/mange/mange.js';
import { getPageTrainEquipmentList, getTrainEquipmentList } from '@/request/api/trainroom/trainroom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			activeName: '1',
			tabledeobj: {},
			tabledeobj1: {},
			// 弹窗
			centerDialogVisible: false,
			diolotitle: '审核预约设备',
			form: {
				resource: '通过',
				desc: ''
			},
			// 查看判断
			looksnum: 1,
			looksnums: 0,
			tabsnun: 10,
			// 实训记录
			pagesize1: 10,
			pageindex1: 1,
			tablednums1: 0,
			// 预约事件
			sletejg: '1',
			pagesize: 10,
			pageindex: 1,
			tablednums: 0,
			tablednumstrain: 0,
			// table组件
			tableData: [],
			tableDatas: [],
			tableDatatrin: [],
			// 标题组件
			paths: [
				{
					path: '/allmanage/orderselete',
					name: '预约实训记录查询'
				}
			],
			DataListobj: {
				pageIndex: 1,
				pageSize: 10,
				sx_tr_guid: '',
				sx_te_guid: '',
				startTime: '',
				endTime: '',
				cla_guid: '',
				si_guid: ''
			},
			DataListobjs: {
				pageIndex: 1,
				pageSize: 10,
				sx_tr_guid: '',
				sx_te_guid: '',
				startTime: '',
				endTime: '',
				cla_guid: '',
				si_guid: ''
			},
			siguid: '',
			// 筛选组件
			filterslist: {
				name: '查询条件',
				content: '请选择查找条件',
				filterlist: [
					{
						id: 0,
						indexsshol: 0,
						title: '所属院校',
						childers: []
					},
					{
						id: 4,
						indexsshol: 0,
						title: '班级',
						childers: []
					},
					{
						id: 1,
						indexsshol: 0,
						title: '实训室',
						childers: []
					},
					{
						id: 2,
						indexsshol: 0,
						title: '实训设备',
						childers: []
					},
					{
						id: 3,
						indexsshol: 0,
						title: '审核状态',
						childers: []
					}
				]
			},
			trainname: '' //实训室名字
		};
	},
	beforeMount() {
		this.getscool();
	},
	mounted() {
		let aitState = ['待审核', '已取消', '已驳回', '审核通过'];
		let Trainstatelist = [
			{
				shoolnem: '全部'
			}
		];
		aitState.forEach((item, index) => {
			Trainstatelist.push({
				shoolnem: item
			});
		});
		this.filterslist.filterlist[4].childers = Trainstatelist;
		// this.getyyclass()
	},
	created() {
		AppOptions.appEmpty = false;
	},
	computed: {
		pagesizes() {
			return Number(this.pagesize);
		},
		pagesize1s() {
			return Number(this.pagesize1);
		}
	},
	methods: {
		changeDataListobjs(DataListobjs) {
			this.DataListobj = DataListobjs;
			this.DataListobjs = DataListobjs;
		},

		handleClick(tab, event) {
			// console.log(tab, event);
			if (this.sletejg == 2) {
				this.getpageaappdata();
			}
		},
		// 获取学校
		getscool() {
			GetbjGetSchoolList().then(res => {
				// console.log(res, "院校不分页")

				this.schoollist = res.data.data;
				if (this.schoollist.length == 1) {
					this.getclasstrain(this.schoollist[0].si_guid);
					this.DataListobjs.si_guid = this.schoollist[0].si_guid;
					this.DataListobj.si_guid = this.schoollist[0].si_guid;
					this.getpageaappdata();
					this.getyyTrainDataList();
					this.schoollist.forEach(item => {
						item.shoolnem = item.si_name_cn;
					});
				} else {
					let trainobj = {
						si_name_cn: '全部',
						shoolid: 0,
						si_guid: ''
					};
					this.getpageaappdata();
					this.getyyTrainDataList();
					this.getclasstrainsy();
					this.schoollist.unshift(trainobj);
					this.schoollist.forEach(item => {
						item.shoolnem = item.si_name_cn;
					});
				}

				this.filterslist.filterlist[0].childers = this.schoollist;
			});
		},
		// 分页
		getclasstrainsy(siguid = '') {
			var allobj = {};
			allobj.shoolnem = '全部';
			allobj.shoolid = '0';
			allobj.cla_guid = '';
			allobj.sx_tr_guid = '';

			let classobj = {
				pageIndex: 1,
				pageSize: 5,
				cla_name: '',
				si_guid: siguid,
				tr_name: ''
			};
			GetbjPageClassList(classobj).then(res => {
				// console.log(res, "班级分页")
				let clalist = [];
				clalist = res.data.data.list;
				clalist.forEach(ite => {
					ite.shoolnem = ite.cla_name;
				});
				clalist.unshift(allobj);

				this.filterslist.filterlist[1].childers = clalist;

				// this.filterslist.filterlist[1].childers = clalist
			});
			let trainobj = {
				pageIndex: 1,
				pageSize: 5,
				si_guid: siguid,
				tr_name: ''
			};
			TrainGetPageTrainList(trainobj).then(res => {
				// console.log(res, "实训室分页")
				let Trainlist = [];
				Trainlist = res.data.data.list;
				Trainlist.forEach(ite => {
					ite.shoolnem = ite.tr_name;
				});

				Trainlist.unshift(allobj);
				if (Trainlist[1]) {
					this.gettrainsbs(Trainlist[1].sx_tr_guid ?? '');
				} else {
					this.gettrainsbs('');
				}
				this.filterslist.filterlist[2].childers = Trainlist;
			});
		},
		// 不分页
		getclasstrain(siguid = '') {
			// console.log(siguid)

			// 学校id
			this.siguid = siguid;
			// console.log(siguid,"idd")
			var allobj = {};
			allobj.shoolnem = '全部';
			allobj.shoolid = '0';
			allobj.cla_guid = '';
			allobj.sx_tr_guid = '';
			ClassInfoGetClassList(siguid).then(res => {
				// console.log(res, "班级不分页")
				let clalist = [];
				clalist = res.data.data;
				clalist.forEach(ite => {
					ite.shoolnem = ite.cla_name;
				});
				clalist.unshift(allobj);

				this.filterslist.filterlist[1].childers = clalist;
			});
			TrainGetTrainList(siguid).then(res => {
				// console.log(res, "实训室不分页")
				let Trainlist = [];
				Trainlist = res.data.data;
				Trainlist.forEach(ite => {
					ite.shoolnem = ite.tr_name;
				});

				Trainlist.unshift(allobj);
				if (Trainlist[1]) {
					this.gettrainsbs(Trainlist[1].sx_tr_guid ?? '');
				} else {
					this.gettrainsbs('');
				}
				this.filterslist.filterlist[2].childers = Trainlist;
			});
		},
		gettrainsbs(sxtrguid = '') {
			var allobj = {};
			allobj.shoolnem = '全部';
			allobj.shoolid = '0';
			allobj.sx_te_guid = '';
			let TrainEquipmeobj = {
				sx_tr_guid: sxtrguid,
				te_deviceName: '',
				si_guid: localStorage.getItem('siguid')
			};
			if (this.siguid != '') {
				TrainEquipmeobj.si_guid = this.siguid;
			}

			// console.log(this.siguid, "学校id")
			getTrainEquipmentList(TrainEquipmeobj).then(res => {
				// console.log(res, "设备不分页")
				let TrainEquipmenlist = [];
				TrainEquipmenlist = res.data.data;
				TrainEquipmenlist.forEach(ite => {
					ite.shoolnem = ite.te_deviceName;
				});

				TrainEquipmenlist.unshift(allobj);
				this.filterslist.filterlist[3].childers = TrainEquipmenlist;

				// console.log(Trainstatelist,"状态列表")
			});
		},

		// 查看
		lookindg(item, trainname) {
			console.log(trainname);
			this.trainname = trainname;
			// console.log("查看预约记录", item)
			this.diolotitle = '查看预约记录';
			this.looksnum = 1;
			this.looksnums = 0;
			this.tabledeobj = item;
			this.centerDialogVisible = true;
		},
		lookstrainjl(item) {
			// 查看实训记录
			console.log(item,'获取id')
			this.$router.push("/usercenter/myrealtestchart?id="+item.TDT_TaskGuid)
			
			// this.diolotitle = '查看实训记录';
			// this.looksnum = 2;
			// this.looksnums = 0;
			// this.tabledeobj1 = item;
			// this.centerDialogVisible = true;
		},

		// 审核
		tabledeletes(item, num) {
			// console.log(item)

			this.diolotitle = num == 1 ? '审核实训室' : '审核实训设备';
			this.looksnum = 1;
			this.looksnums = 3;
			this.tabledeobj = item;
			this.centerDialogVisible = true;
		},
		oktable() {
			// this.centerDialogVisible = false
			let shbleobj = {
				sx_ap_guid: this.tabledeobj.sx_ap_guid,
				isagree: this.form.resource == '通过' ? true : false,
				ap_auditGuid: localStorage.getItem('uiguid'),
				ap_auditContent: this.desc ?? ''
			};
			// console.log(shbleobj)
			if (this.looksnum == 1 && this.looksnums == 3) {
				AppointmentOnAudit(shbleobj).then(res => {
					// console.log(res)
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.centerDialogVisible = false;

						this.form.desc = '';
						this.getyyTrainDataList();
						this.getpageaappdata();
						this.desc = '';
					} else {
						this.$message(res.data.msg);
					}
				});
			} else {
				this.centerDialogVisible = false;
			}
		},
		changetable() {
			this.sletejg = 1;
		},
		changetables() {
			this.sletejg = 2;
		},
		// 表格页面
		handleCurrentChange(val) {
			this.DataListobj.pageIndex = val;
			this.getpageaappdata();
		},
		handleCurrentChange1(val) {
			this.DataListobjs.pageIndex = val;
			this.getyyTrainDataList();
		},

		changetavles() {
			this.DataListobj.pageSize = this.pagesize;
			this.getpageaappdata();
		},
		paginationschnge() {
			this.DataListobjs.pageSize = this.pagesize1;
			this.getyyTrainDataList();
		},

		// 实训记录
		getyyTrainDataList(DataLi = this.DataListobjs) {
			// console.log(DataLi)
			// console.log(this.DataListobjs)
			// GetPageTrainDataList(DataLi).then(res => {
			GetPageTrainDataListApi(DataLi).then(res => {
				// console.log(res, "实训记录")
				this.tableDatas = res.data.data.list;
				this.tablednums1 = res.data.data.totalCount;
			});
		},
		// 预约记录
		getpageaappdata(DataListobjs = this.DataListobj) {
			this.DataListobj = DataListobjs;
			GetPageAppointDataList(this.DataListobj).then(res => {
				// console.log(res, "预约记录")
				this.tableData = res.data.data.list;
				this.tablednums = res.data.data.totalCount;
			});

			GetPagesxAppointDataList(this.DataListobj).then(res => {
				// console.log(res, "实训室预约记录")
				this.tableDatatrin = res.data.data.list;
				this.tablednumstrain = res.data.data.totalCount;
			});
		},
		// 成绩导出（分页拉取全部符合条件的实训记录后导出）
		async exportTrainResults() {
			const total = Number(this.tablednums1) || 0;
			if (!total) {
				this.$message.warning('暂无可导出的成绩数据');
				return;
			}
			const pageSize = 200;
			let allList = [];
			let pageIndex = 1;
			while (allList.length < total) {
				const params = {
					pageIndex: pageIndex,
					pageSize: pageSize,
					sx_tr_guid: this.DataListobjs.sx_tr_guid,
					sx_te_guid: this.DataListobjs.sx_te_guid,
					startTime: this.DataListobjs.startTime,
					endTime: this.DataListobjs.endTime,
					cla_guid: this.DataListobjs.cla_guid,
					si_guid: this.DataListobjs.si_guid
				};
				try {
					const res = await GetPageTrainDataListApi(params);
					const list = (res && res.data && res.data.data && res.data.data.list) || [];
					allList = allList.concat(list);
					if (list.length === 0) break;
					pageIndex++;
				} catch (err) {
					console.error('成绩导出失败', err);
					this.$message.error('导出失败，请稍后重试');
					return;
				}
			}
			allList = allList.slice(0, total);
			if (allList.length === 0) {
				this.$message.warning('暂无可导出的成绩数据');
				return;
			}
			const fields = {
				ui_realName: '真实姓名',
				TDT_EndTime: '实训时间',
				tr_name: '实训室',
				te_deviceName: '设备',
				projectName: '实训项目',
				projecScore: '实训成绩'
			};
			const exportList = allList.map(item => ({
				ui_realName: item.ui_realName,
				TDT_EndTime: item.TDT_EndTime,
				tr_name: item.tr_name,
				te_deviceName: item.te_deviceName,
				projectName: item.projectName,
				projecScore: item.projecScore != null ? item.projecScore + '分' : ''
			}));
			xlsx(exportList, fields, '实训成绩导出');
			this.$message.success('导出成功');
		}
	},

	components: {
		titles,
		filters
	}
};
</script>

<style scoped lang="less">
/deep/ .el-table_59_column_406 {
	text-align: center;
	img {
		border-radius: 50%;
	}
}
/deep/ .el-table_62_column_444 {
	text-align: center;
}

.rands {
	border-radius: 50%;
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}

/deep/ .el-dropdown-menu {
	padding: 10px;
}

/* 设置持续时间和动画函数 */
.v-enter-active,
.v-leave-active {
	transition: all 0.8s ease;
}

.v-enter,
.v-leave-to {
	transform: translateX(100px);
	opacity: 0;
}

.core {
	border-top: 4px solid #3e6bff !important;

	.schooltitle {
		color: #3e6bff !important;

		span.icnns {
			background: #3e6bff !important;
		}
	}
}

.orderstable {
	margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ffa319;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar-thumb {
			background: linear-gradient(to right, #2e61bf, #60c363);
			width: 1px;
			border-radius: 4px;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			// th,
			// td {
			// 	text-align: center;

			// }

			td {
				button {
					color: #fff;
					border-radius: 5px;
				}

				.looking {
					background: #0d6efd;
					margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ffa319;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		.schoolconten {
			font-size: 0.8rem;
			margin-left: 0.6rem;
			color: #333;
			letter-spacing: 1px;

			i {
				color: red;
			}
		}

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			width: 3rem;
			height: 3rem;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 2rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ffa319;
			color: #fff;
		}
	}
}
</style>
